import {
  CartAddItemsRequest,
  CartAddItemsResponse,
  CartAddRequest,
  CartItemNoteRequest,
  CartRemoveRequest,
  CartSearchRequest,
  CartSearchResponse,
  CurrentCartResponse,
} from '@api/types';
import { api } from './api';

export const cartApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentCart: builder.query<CurrentCartResponse, void>({
      providesTags: ['Cart'],
      query: () => ({
        method: 'GET',
        url: `api/cart/current`,
      }),
    }),

    clearCurrentCart: builder.mutation<any, any>({
      invalidatesTags: ['Cart'],
      query: () => ({
        method: 'POST',
        url: `api/cart/clear`,
      }),
    }),

    addCartItem: builder.mutation<CurrentCartResponse, CartAddRequest>({
      invalidatesTags: ['Cart'],
      query: (body) => ({
        method: 'POST',
        url: `api/cart/add-item`,
        body,
      }),
    }),

    addCartItems: builder.mutation<CartAddItemsResponse, CartAddItemsRequest>({
      invalidatesTags: ['Cart'],
      query: (body) => ({
        method: 'POST',
        url: `api/cart/add-items`,
        body,
      }),
    }),

    removeCartItem: builder.mutation<CurrentCartResponse, CartRemoveRequest>({
      invalidatesTags: ['Cart'],
      query: (body) => ({
        method: 'POST',
        url: `api/cart/remove-item`,
        body,
      }),
    }),

    changeCartItemQuantity: builder.mutation<CurrentCartResponse, CartRemoveRequest>({
      invalidatesTags: ['Cart'],
      query: (body) => ({
        method: 'POST',
        url: `api/cart/change-item-quantity`,
        body,
      }),
    }),

    saveCartAsDraft: builder.mutation<any, any>({
      invalidatesTags: ['Cart'],
      query: () => ({
        method: 'POST',
        url: `api/cart/save-as-draft`,
      }),
    }),

    cartSearch: builder.query<CartSearchResponse, CartSearchRequest>({
      query: (body) => ({
        method: 'POST',
        url: `api/content/cart-search`,
        body,
      }),
    }),

    // Notes
    cartItemNote: builder.mutation<CurrentCartResponse, CartItemNoteRequest>({
      invalidatesTags: ['Cart'],
      query: (body) => ({
        method: 'POST',
        url: `api/cart/item-note`,
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCurrentCartQuery,
  useAddCartItemMutation,
  useAddCartItemsMutation,
  useRemoveCartItemMutation,
  useClearCurrentCartMutation,
  useChangeCartItemQuantityMutation,
  useSaveCartAsDraftMutation,
  useLazyCartSearchQuery,
  useCartItemNoteMutation,
} = cartApi;
